import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sprint",
  "use": "icon-sprint-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-sprint\"><path d=\"M257.536 260.608h284.672v87.04H257.536zM560.64 725.504h342.528v64h-342.528zM257.536 449.024h380.928v87.04H257.536z\" p-id=\"5632\" /><path d=\"M699.904 586.24h64v342.528h-64z\" p-id=\"5633\" /><path d=\"M172.032 879.616v16.384c0-9.216-7.168-16.384-16.384-16.384h16.384V133.632h-16.384c9.216 0 16.384-7.168 16.384-16.384v16.384h680.96v-16.384c0 9.728 7.168 16.384 15.872 16.384h-15.872v279.04h50.176V131.584c0-26.112-20.992-47.104-47.104-47.104H167.936c-26.112 0-47.104 20.992-47.104 47.104v750.08c0 26.112 20.992 47.104 47.104 47.104h214.016v-49.664h-209.92v0.512z\" p-id=\"5634\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sprint.svg
// module id = fogn
// module chunks = 77